import { useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import styled from "@emotion/styled";
import dayjs from "dayjs";
import NavBar from "components/navbar/NavBar";
import SideBar from "components/sidebar/Sidebar";
import {
  useGetGameLazyQuery,
  useGetGamesQuery,
  useGetMeQuery,
} from "generated/graphql";
import Auth from "lib/auth";

const TournamentsPageWrapper = styled.div`
  /* Game filter */

  .sidebar ul {
    display: none;
  }

  .game-filter-container {
    margin-left: 250px;

    button {
      background: none;
      border: 0;
      cursor: pointer;
      padding: 0;
      margin: 0;
    }

    @media (max-width: 1024px) {
      h2 {
        margin-left: 4rem;
        margin-top: 1.5rem;
      }

      h3 {
        margin-left: 3rem;
        margin-top: 3rem;
      }
      margin-left: 0;
      padding: 1rem;

      .games-list {
        display: grid;
        grid-template-columns: 1fr 1fr;
        justify-items: start;
        row-gap: 1rem;
        margin-left: 3rem;
        margin-top: 2rem;
      }
    }
  }

  .game-filter-container img {
    /* width: 100px; */
    height: 134px;
    padding-right: 30px;
  }

  .grid-container a {
    @media (max-width: 720px) {
      display: block;
      min-height: 175px;
    }
  }
`;

function TournamentsPage() {
  const { data, loading } = useGetMeQuery({
    nextFetchPolicy: "cache-first",
  });
  const {
    data: games,
    loading: loadingGames,
    error,
  } = useGetGamesQuery({
    nextFetchPolicy: "cache-first",
  });
  const [getGame, { data: game }] = useGetGameLazyQuery({
    nextFetchPolicy: "cache-first",
  });
  const [activeGame, setActiveGame] = useState(undefined);

  if (error) {
    new Auth().clearToken();
    // document.location.reload()
  }

  return (
    <TournamentsPageWrapper>
      <Helmet>
        <title>Tournaments — Jiwe eSports</title>
      </Helmet>
      <div className="wrapper">
        <SideBar
          nickname={data?.me?.nickname}
          isLoggedIn={!!data?.me?.nickname}
        />
        {!loading && data && (
          <NavBar nickname={data?.me?.nickname} name={data.me?.name} />
        )}
      </div>

      <div className="game-filter-container">
        <h2>Tournaments</h2>
        <h3>Filter by game</h3>
        <div className="games-list">
          {!loadingGames &&
            games?.games.map((g) => (
              <button
                key={g.id}
                onClick={() => {
                  setActiveGame(g.id);
                  getGame({ variables: { gameId: g.id } });
                }}
              >
                <img
                  src={g.poster_url!}
                  alt=""
                  style={{
                    filter:
                      activeGame === g.id ? "grayscale(0)" : "grayscale(1)",
                    opacity: activeGame === g.id ? 1 : 0.5,
                  }}
                />
              </button>
            ))}
        </div>
        <br />
        {!!game?.game && (
          <h4 style={{ fontWeight: "bold" }}>{game?.game?.name}</h4>
        )}
      </div>
      {activeGame && games?.games && (
        <div className="grid-container" style={{ marginLeft: "-1em" }}>
          {game?.game?.tournaments.map((tournament) => (
            <Link to={`/tournaments/${tournament.id}`} key={tournament.id}>
              <div className="parent1">
                <div className="torn1">
                  <img
                    src={
                      tournament?.tournament_details.filter(
                        ({ key }) => key === "posterURL"
                      )[0] &&
                      tournament?.tournament_details.filter(
                        ({ key }) => key === "posterURL"
                      )[0].value
                        ? tournament?.tournament_details.filter(
                            ({ key }) => key === "posterURL"
                          )[0].value!
                        : "/images/BackTournaments.png"
                    }
                    alt=""
                  />
                </div>
                <div className="torn2">
                  <img src={game?.game?.poster_url!} alt="" />
                </div>
                <div className="TournInfo">
                  <>
                    {tournament.tournament_details.filter(
                      ({ key }) => key === "tournamentStartTime"
                    )[0] && (
                      <p>
                        {dayjs(
                          tournament?.tournament_date[0],
                          "YYYY-MM-DD"
                        ).format("ddd	D MMM")}{" "}
                        @{" "}
                        {dayjs(
                          // @ts-ignore
                          tournament.tournament_details.filter(
                            ({ key }) => key === "tournamentStartTime"
                          )[0]!.value,
                          "YYYY-MM-DDTHH:mm:ss+Z"
                        ).format("h:mmA")}
                      </p>
                    )}
                    <p>
                      <b>{tournament.name}</b>
                    </p>
                    {tournament.tournament_details.filter(
                      ({ key }) => key === "prize"
                    )[0] && (
                      <p>
                        Prize: KES{" "}
                        {
                          tournament.tournament_details.filter(
                            ({ key }) => key === "prize"
                          )[0].value!
                        }
                      </p>
                    )}
                  </>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </TournamentsPageWrapper>
  );
}

export default TournamentsPage;
